
import { Vue, Component, Ref, Prop, Watch } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';


@Component
export default class VehicleSourcePriceInformationField extends Vue {
  @Ref()
  childFormRef!: FormModel;

  formModel = {
    price: '',
    officialPrice: '',
    managerPrice: '',
    sellerPrice: '',
  };

  rules = {
    price: [{ required: true, message: '请输入销售价格' }],
    // officialPrice: [{ required: true, message: '请输入新车价格' }],
    // managerPrice: [{ required: true, message: '请输入新车价格' }],
    // sellerPrice: [{ required: true, message: '请输入新车价格' }],

  };

  @Prop()
  value!: any;

  @Prop()
  readonly!: boolean;

  @Watch('formModel.price')
  price() {
    this.handleFormModelChange();
  }

  @Watch('formModel.interiorInfo')
  interiorInfo() {
    this.handleFormModelChange();
  }

  handleFormModelChange() {
    this.$emit('update', this.formModel);
  }


  mounted() {
    this.handleValueChange();
  }

  @Watch('value')
  handleValueChange() {
    this.formModel = this.value;
  }

  public async validateFields(): Promise<boolean> {
    try {
      const valid = await (this.childFormRef as any).validate();
      return valid;
    } catch (error) {
      // console.error('子表单校验失败:', error);
      return false;
    }
  }
}

